import React, { useState, useEffect } from 'react';
import ApiService from '../services/api';
import {
    MonitorCog , SquareActivity , Tickets , Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings,
    Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown,
    Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock,
    DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut,
    ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User,
    Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash,
    Cable, Grid, Cpu, Router, Network, HardDrive, Server, MonitorSpeaker,
    Radio, Wifi, Database, CircuitBoard, Power, PlugZap, UserCog, Calculator,
    Ruler, Weight, Thermometer, Gauge, ArrowLeftRight, Copy, RotateCcw,
    Bookmark, History, Zap as Lightning, ArrowUpDown, Construction, Beaker, Leaf, ShieldCheck, Folder , Receipt , Briefcase
} from 'lucide-react';
import '../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';

const UnitechEngineeringConversions = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('conversions');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('length');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedConversion, setSelectedConversion] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [outputValue, setOutputValue] = useState('');
    const [isReversed, setIsReversed] = useState(false);
    const navigate = useNavigate();

    const [conversionCategories, setConversionCategories] = useState([]);
    const [conversions, setConversions] = useState([]);
    const [favorites, setFavorites] = useState([]);
    const [conversionHistory, setConversionHistory] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedConversionData, setSelectedConversionData] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        category: 'length',
        fromUnit: '',
        toUnit: '',
        factor: '',
        description: '',
        formula: '',
        precision: 6
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadConversionCategories();
            loadConversions();
            loadFavorites();
            loadConversionHistory();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            const timeoutId = setTimeout(() => {
                loadConversions();
            }, 300); 

            return () => clearTimeout(timeoutId);
        }
    }, [selectedCategory, searchTerm, user]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (selectedConversion && inputValue !== '') {
            performConversion();
        } else {
            setOutputValue('');
        }
    }, [selectedConversion, inputValue, isReversed]);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);
            
            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadConversionCategories = async () => {
        try {
            const response = await ApiService.getConversionCategories();
            if (response.success) {
                setConversionCategories(response.categories);
            }
        } catch (error) {
            console.error('Failed to load conversion categories:', error);
            setConversionCategories([
                { id: 'length', name: 'Length & Distance', icon: 'Ruler', color: '#3b82f6', count: 15 },
                { id: 'area', name: 'Area', icon: 'Grid', color: '#10b981', count: 8 },
                { id: 'volume', name: 'Volume', icon: 'Box', color: '#f59e0b', count: 12 },
                { id: 'weight', name: 'Weight & Mass', icon: 'Weight', color: '#ef4444', count: 10 },
                { id: 'temperature', name: 'Temperature', icon: 'Thermometer', color: '#8b5cf6', count: 6 },
                { id: 'pressure', name: 'Pressure', icon: 'Gauge', color: '#06b6d4', count: 9 },
                { id: 'force', name: 'Force', icon: 'Zap', color: '#84cc16', count: 7 },
                { id: 'energy', name: 'Energy & Power', icon: 'Lightning', color: '#f97316', count: 11 },
                { id: 'speed', name: 'Speed & Velocity', icon: 'ArrowRight', color: '#ec4899', count: 8 },
                { id: 'angle', name: 'Angle', icon: 'RotateCcw', color: '#6366f1', count: 4 }
            ]);
        }
    };

    const loadConversions = async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            const params = {
                category: selectedCategory !== 'all' ? selectedCategory : undefined,
                search: searchTerm || undefined,
                page: pagination.page
            };

            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            const response = await ApiService.getConversions(params);
            if (response.success) {
                setConversions(response.conversions || []);
                setPagination({
                    page: response.page || 1,
                    pages: response.pages || 1,
                    total: response.total || 0
                });
                
                // Auto-select first conversion if none selected
                if (!selectedConversion && response.conversions?.length > 0) {
                    setSelectedConversion(response.conversions[0]);
                }
            }
        } catch (error) {
            console.error('Failed to load conversions:', error);
            setError('Erreur lors du chargement des conversions');
            setConversions([]);
            setPagination({ page: 1, pages: 1, total: 0 });
        } finally {
            setIsLoading(false);
        }
    };

    const loadFavorites = async () => {
        try {
            const response = await ApiService.getFavoriteConversions();
            if (response.success) {
                setFavorites(response.favorites || []);
            }
        } catch (error) {
            console.error('Failed to load favorites:', error);
        }
    };

    const loadConversionHistory = async () => {
        try {
            const response = await ApiService.getConversionHistory();
            if (response.success) {
                setConversionHistory(response.history || []);
            }
        } catch (error) {
            console.error('Failed to load conversion history:', error);
        }
    };

    const performConversion = () => {
        if (!selectedConversion || !inputValue) return;

        try {
            const numValue = parseFloat(inputValue);
            if (isNaN(numValue)) {
                setOutputValue('');
                return;
            }

            let result;
            if (isReversed) {
                result = numValue / selectedConversion.factor;
            } else {
                result = numValue * selectedConversion.factor;
            }

            const precision = selectedConversion.precision || 6;
            setOutputValue(parseFloat(result.toPrecision(precision)).toString());

            saveConversionToHistory(numValue, result);
        } catch (error) {
            console.error('Conversion error:', error);
            setOutputValue('Error');
        }
    };

    const saveConversionToHistory = async (input, output) => {
        try {
            const historyEntry = {
                conversionId: selectedConversion._id,
                fromValue: isReversed ? output : input,
                toValue: isReversed ? input : output,
                fromUnit: isReversed ? selectedConversion.toUnit : selectedConversion.fromUnit,
                toUnit: isReversed ? selectedConversion.fromUnit : selectedConversion.toUnit,
                timestamp: new Date()
            };

            await ApiService.saveConversionHistory(historyEntry);
            loadConversionHistory(); 
        } catch (error) {
            console.error('Failed to save conversion history:', error);
        }
    };

    const toggleFavorite = async (conversionId) => {
        try {
            const isFavorite = favorites.some(fav => fav.conversionId === conversionId);
            
            if (isFavorite) {
                await ApiService.removeFavoriteConversion(conversionId);
            } else {
                await ApiService.addFavoriteConversion(conversionId);
            }
            
            loadFavorites();
        } catch (error) {
            console.error('Failed to toggle favorite:', error);
        }
    };

    const handleRefresh = () => {
        loadConversions();
        loadConversionCategories();
        loadFavorites();
        loadConversionHistory();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            name: '',
            category: selectedCategory,
            fromUnit: '',
            toUnit: '',
            factor: '',
            description: '',
            formula: '',
            precision: 6
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
    };

    const openEditModal = (conversion) => {
        setSelectedConversionData(conversion);
        setFormData({
            name: conversion.name,
            category: conversion.category,
            fromUnit: conversion.fromUnit,
            toUnit: conversion.toUnit,
            factor: conversion.factor.toString(),
            description: conversion.description || '',
            formula: conversion.formula || '',
            precision: conversion.precision || 6
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedConversionData(null);
        setFormError('');
    };

    const openViewModal = (conversion) => {
        setSelectedConversionData(conversion);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedConversionData(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddConversion = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.name || !formData.fromUnit || !formData.toUnit || !formData.factor) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const conversionData = {
                name: formData.name,
                category: formData.category,
                fromUnit: formData.fromUnit,
                toUnit: formData.toUnit,
                factor: parseFloat(formData.factor),
                description: formData.description,
                formula: formData.formula,
                precision: parseInt(formData.precision)
            };

            const response = await ApiService.createConversion(conversionData);
            
            if (response.success) {
                alert('Conversion créée avec succès ! 🎉');
                closeAddModal();
                loadConversions();
                loadConversionCategories();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la création de la conversion');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditConversion = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.name || !formData.fromUnit || !formData.toUnit || !formData.factor) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const conversionData = {
                name: formData.name,
                category: formData.category,
                fromUnit: formData.fromUnit,
                toUnit: formData.toUnit,
                factor: parseFloat(formData.factor),
                description: formData.description,
                formula: formData.formula,
                precision: parseInt(formData.precision)
            };

            const response = await ApiService.updateConversion(selectedConversionData._id, conversionData);
            
            if (response.success) {
                alert('Conversion mise à jour avec succès ! ✅');
                closeEditModal();
                loadConversions();
                loadConversionCategories();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteConversion = async (conversionId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cette conversion ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteConversion(conversionId);
                if (response.success) {
                    loadConversions();
                    loadConversionCategories();
                    alert('Conversion supprimée avec succès');
                    
                    if (selectedConversion?._id === conversionId) {
                        setSelectedConversion(null);
                        setInputValue('');
                        setOutputValue('');
                    }
                }
            } catch (error) {
                console.error('Failed to delete conversion:', error);
                alert('Erreur lors de la suppression de la conversion: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            // Nettoyer les données utilisateur
            ApiService.clearUserData();
            
            // Utiliser React Router pour naviguer vers login
            navigate('/login');
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            alert('Valeur copiée ! 📋');
        });
    };

    const swapUnits = () => {
        setIsReversed(!isReversed);
        const temp = inputValue;
        setInputValue(outputValue);
        setOutputValue(temp);
    };


const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const getCategoryIcon = (iconName) => {
        const iconMap = {
            'Ruler': Ruler,
            'Grid': Grid,
            'Box': Box,
            'Weight': Weight,
            'Thermometer': Thermometer,
            'Gauge': Gauge,
            'Zap': Zap,
            'Lightning': Lightning,
            'ArrowRight': ArrowRight,
            'RotateCcw': RotateCcw
        };
        return iconMap[iconName] || Calculator;
    };

    if (isAuthChecking) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    return (
        <div className="dashboard-container">
            {/* ADD CONVERSION MODAL */}
            {showAddModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#1e40af',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Calculator style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Ajouter Conversion
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Créez une nouvelle conversion d'ingénierie
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeAddModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        <form onSubmit={handleAddConversion}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Nom de la conversion *
                                        </label>
                                        <input
                                            type="text" name="name" value={formData.name} onChange={handleInputChange}
                                            placeholder="ex: Mètres vers Pieds" required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Catégorie *
                                        </label>
                                        <select name="category" value={formData.category} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {conversionCategories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Unité source *
                                        </label>
                                        <input
                                            type="text" name="fromUnit" value={formData.fromUnit} onChange={handleInputChange}
                                            placeholder="ex: mètres" required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Unité cible *
                                        </label>
                                        <input
                                            type="text" name="toUnit" value={formData.toUnit} onChange={handleInputChange}
                                            placeholder="ex: pieds" required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Facteur de conversion *
                                        </label>
                                        <input
                                            type="number" name="factor" value={formData.factor} onChange={handleInputChange}
                                            placeholder="ex: 3.28084" step="any" required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Formule (optionnel)
                                        </label>
                                        <input
                                            type="text" name="formula" value={formData.formula} onChange={handleInputChange}
                                            placeholder="ex: pieds = mètres × 3.28084"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Précision
                                        </label>
                                        <input
                                            type="number" name="precision" value={formData.precision} onChange={handleInputChange}
                                            min="1" max="15" defaultValue="6"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description (optionnel)
                                    </label>
                                    <textarea
                                        name="description" value={formData.description} onChange={handleInputChange}
                                        placeholder="Description ou notes sur cette conversion..." rows="3"
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeAddModal}
                                    style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Annuler
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                    style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#1e40af', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Création...
                                        </>
                                    ) : (
                                        <>
                                            <Calculator style={{ width: '16px', height: '16px' }} />
                                            Créer la conversion
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* EDIT CONVERSION MODAL */}
            {showEditModal && selectedConversionData && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Conversion
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedConversionData.name}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        <form onSubmit={handleEditConversion}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Nom de la conversion *
                                        </label>
                                        <input
                                            type="text" name="name" value={formData.name} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Catégorie *
                                        </label>
                                        <select name="category" value={formData.category} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {conversionCategories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Unité source *
                                        </label>
                                        <input
                                            type="text" name="fromUnit" value={formData.fromUnit} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Unité cible *
                                        </label>
                                        <input
                                            type="text" name="toUnit" value={formData.toUnit} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Facteur de conversion *
                                        </label>
                                        <input
                                            type="number" name="factor" value={formData.factor} onChange={handleInputChange} step="any" required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Formule (optionnel)
                                        </label>
                                        <input
                                            type="text" name="formula" value={formData.formula} onChange={handleInputChange}
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Précision
                                        </label>
                                        <input
                                            type="number" name="precision" value={formData.precision} onChange={handleInputChange} min="1" max="15"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description (optionnel)
                                    </label>
                                    <textarea
                                        name="description" value={formData.description} onChange={handleInputChange} rows="3"
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                    style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Annuler
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                    style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Mise à jour...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Mettre à jour
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* VIEW CONVERSION MODAL */}
            {showViewModal && selectedConversionData && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#059669',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Détails de la Conversion
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedConversionData.name}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CATÉGORIE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {conversionCategories.find(c => c.id === selectedConversionData.category)?.name || selectedConversionData.category}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>FACTEUR</label>
                                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                                        {selectedConversionData.factor}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>UNITÉ SOURCE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedConversionData.fromUnit}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>UNITÉ CIBLE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedConversionData.toUnit}
                                    </p>
                                </div>
                            </div>

                            {selectedConversionData.formula && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>FORMULE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontFamily: 'monospace', backgroundColor: '#f3f4f6', padding: '8px', borderRadius: '4px' }}>
                                        {selectedConversionData.formula}
                                    </p>
                                </div>
                            )}

                            {selectedConversionData.description && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                        {selectedConversionData.description}
                                    </p>
                                </div>
                            )}

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRÉCISION</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {selectedConversionData.precision || 6} chiffres significatifs
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CRÉÉ LE</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {selectedConversionData.createdAt ? new Date(selectedConversionData.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Fermer
                        </button>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Calculator style={{ width: '16px', height: '16px' }} />
                                    <span>Engineering Conversions</span>
                                </div>
                            </nav>
                        </div>

                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* Engineering Conversions Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Engineering Conversions Portal</h1>
                        <p className="page-subtitle">
                            Professional conversion tools for construction, engineering, and building materials calculations.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <Calculator style={{ width: '16px', height: '16px' }} />
                                Ajouter Conversion
                            </button>
                            <button className="action-button secondary">
                                <Download style={{ width: '16px', height: '16px' }} />
                                Exporter Conversions
                            </button>
                            <button className="action-button secondary">
                                <Bookmark style={{ width: '16px', height: '16px' }} />
                                Mes Favoris ({favorites.length})
                            </button>
                        </div>
                    </div>

                    {/* Categories Section */}
                    <div className="categories-section">
                        <h2 className="section-title">Catégories de Conversions</h2>
                        <div className="categories-grid">
                            {conversionCategories.map((category) => {
                                const IconComponent = getCategoryIcon(category.icon);
                                return (
                                    <div
                                        key={category.id}
                                        className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                                        onClick={() => setSelectedCategory(category.id)}
                                        style={{ 
                                            cursor: 'pointer',
                                            borderColor: selectedCategory === category.id ? category.color : '#e5e7eb'
                                        }}
                                    >
                                        <div className="category-header">
                                            <div className="category-icon" style={{ backgroundColor: category.color }}>
                                                <IconComponent style={{ width: '20px', height: '20px', color: 'white' }} />
                                            </div>
                                            <h3 className="category-name">{category.name}</h3>
                                        </div>
                                        <p className="category-count">{category.count} conversions</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Calculator Section */}
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 400px', 
                        gap: '24px', 
                        marginBottom: '32px' 
                    }}>
                        {/* Conversions List */}
                        <div className="conversions-section">
                            <div className="filters-section">
                                <div className="filters-row">
                                    <div className="filter-group">
                                        <label className="filter-label">Recherche</label>
                                        <input
                                            type="text"
                                            className="filter-input"
                                            placeholder="Nom, unité source, unité cible..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="filter-group">
                                        <label className="filter-label">Actions</label>
                                        <button className="action-button secondary">
                                            <Filter style={{ width: '16px', height: '16px' }} />
                                            Filtres avancés
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="table-header">
                                <h2 className="table-title">
                                    {selectedCategory === 'all' ? 'Toutes les conversions' : 
                                     conversionCategories.find(c => c.id === selectedCategory)?.name || 'Conversions'}
                                </h2>
                                <span className="table-stats">
                                    {pagination.total} conversion{pagination.total > 1 ? 's' : ''} trouvée{pagination.total > 1 ? 's' : ''}
                                    {isLoading && ' (chargement...)'}
                                </span>
                            </div>

                            <table className="products-table">
                                <thead className="table-head">
                                    <tr>
                                        <th>Nom</th>
                                        <th>Unité Source</th>
                                        <th>Unité Cible</th>
                                        <th>Facteur</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {conversions.map((conversion) => {
                                        const isFavorite = favorites.some(fav => fav.conversionId === conversion._id);
                                        return (
                                            <tr 
                                                key={conversion._id}
                                                className={selectedConversion?._id === conversion._id ? 'selected' : ''}
                                                onClick={() => setSelectedConversion(conversion)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span style={{ fontWeight: '500' }}>{conversion.name}</span>
                                                        {isFavorite && (
                                                            <Star style={{ width: '14px', height: '14px', color: '#f59e0b', fill: '#f59e0b' }} />
                                                        )}
                                                    </div>
                                                </td>
                                                <td>{conversion.fromUnit}</td>
                                                <td>{conversion.toUnit}</td>
                                                <td style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                    {conversion.factor}
                                                </td>
                                                <td>
                                                    <div className="actions-cell">
                                                        <button 
                                                            className="action-icon" 
                                                            title="Voir détails"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openViewModal(conversion);
                                                            }}
                                                        >
                                                            <Eye style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                        <button 
                                                            className="action-icon" 
                                                            title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleFavorite(conversion._id);
                                                            }}
                                                        >
                                                            <Star style={{ 
                                                                width: '16px', 
                                                                height: '16px',
                                                                color: isFavorite ? '#f59e0b' : '#6b7280',
                                                                fill: isFavorite ? '#f59e0b' : 'none'
                                                            }} />
                                                        </button>
                                                        {(user.role === 'manager' || user.role === 'admin') && (
                                                            <button 
                                                                className="action-icon edit" 
                                                                title="Modifier"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openEditModal(conversion);
                                                                }}
                                                            >
                                                                <Edit style={{ width: '16px', height: '16px' }} />
                                                            </button>
                                                        )}
                                                        {user.role === 'admin' && (
                                                            <button 
                                                                className="action-icon delete" 
                                                                title="Supprimer"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteConversion(conversion._id);
                                                                }}
                                                            >
                                                                <Trash2 style={{ width: '16px', height: '16px' }} />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            {conversions.length === 0 && !isLoading && (
                                <div style={{ 
                                    padding: '40px', 
                                    textAlign: 'center', 
                                    color: '#64748b',
                                    borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                                }}>
                                    <Calculator style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                    <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                        Aucune conversion trouvée
                                    </p>
                                    <p style={{ fontSize: '14px' }}>
                                        Essayez de modifier vos critères de recherche ou ajoutez de nouvelles conversions.
                                    </p>
                                </div>
                            )}

                            {isLoading && (
                                <div style={{ 
                                    padding: '40px', 
                                    textAlign: 'center', 
                                    color: '#64748b'
                                }}>
                                    <RefreshCw style={{ 
                                        width: '24px', 
                                        height: '24px', 
                                        margin: '0 auto 16px', 
                                        animation: 'spin 1s linear infinite' 
                                    }} />
                                    <p>Chargement des conversions...</p>
                                </div>
                            )}
                        </div>

                        {/* Calculator Panel */}
                        <div style={{
                            backgroundColor: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '24px',
                            height: 'fit-content',
                            position: 'sticky',
                            top: '20px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                marginBottom: '20px',
                                paddingBottom: '16px',
                                borderBottom: '2px solid #e5e7eb'
                            }}>
                                <div style={{
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor: '#1e40af',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Calculator style={{ width: '16px', height: '16px', color: 'white' }} />
                                </div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                        Calculateur de Conversion
                                    </h3>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280' }}>
                                        {selectedConversion ? selectedConversion.name : 'Sélectionnez une conversion'}
                                    </p>
                                </div>
                            </div>

                            {selectedConversion ? (
                                <div>
                                    {/* Conversion Info */}
                                    <div style={{
                                        backgroundColor: '#f8fafc',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        marginBottom: '16px',
                                        fontSize: '13px'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                            <span style={{ color: '#6b7280' }}>Facteur:</span>
                                            <span style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                {selectedConversion.factor}
                                            </span>
                                        </div>
                                        {selectedConversion.formula && (
                                            <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280' }}>
                                                <strong>Formule:</strong> {selectedConversion.formula}
                                            </div>
                                        )}
                                    </div>

                                    {/* Input Section */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            {isReversed ? selectedConversion.toUnit : selectedConversion.fromUnit}
                                        </label>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                type="number"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                placeholder="Entrez une valeur..."
                                                step="any"
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    paddingRight: '40px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    boxSizing: 'border-box',
                                                    transition: 'border-color 0.2s',
                                                    ':focus': {
                                                        borderColor: '#1e40af',
                                                        outline: 'none'
                                                    }
                                                }}
                                            />
                                            <button
                                                onClick={() => copyToClipboard(inputValue)}
                                                style={{
                                                    position: 'absolute',
                                                    right: '8px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    padding: '4px',
                                                    border: 'none',
                                                    background: 'none',
                                                    cursor: 'pointer',
                                                    opacity: inputValue ? 1 : 0.3
                                                }}
                                                disabled={!inputValue}
                                            >
                                                <Copy style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Swap Button */}
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                                        <button
                                            onClick={swapUnits}
                                            style={{
                                                padding: '8px 16px',
                                                border: '1px solid #d1d5db',
                                                background: 'white',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                color: '#374151',
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            <ArrowUpDown style={{ width: '14px', height: '14px' }} />
                                            Inverser
                                        </button>
                                    </div>

                                    {/* Output Section */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            {isReversed ? selectedConversion.fromUnit : selectedConversion.toUnit}
                                        </label>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                type="text"
                                                value={outputValue}
                                                readOnly
                                                placeholder="Résultat..."
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    paddingRight: '40px',
                                                    border: '2px solid #10b981',
                                                    borderRadius: '8px',
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    backgroundColor: '#f0fdf4',
                                                    color: '#059669',
                                                    boxSizing: 'border-box'
                                                }}
                                            />
                                            <button
                                                onClick={() => copyToClipboard(outputValue)}
                                                style={{
                                                    position: 'absolute',
                                                    right: '8px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    padding: '4px',
                                                    border: 'none',
                                                    background: 'none',
                                                    cursor: 'pointer',
                                                    opacity: outputValue ? 1 : 0.3
                                                }}
                                                disabled={!outputValue}
                                            >
                                                <Copy style={{ width: '16px', height: '16px', color: '#059669' }} />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Quick Actions */}
                                    <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
                                        <button
                                            onClick={() => {
                                                setInputValue('');
                                                setOutputValue('');
                                            }}
                                            style={{
                                                flex: 1,
                                                padding: '8px 12px',
                                                border: '1px solid #d1d5db',
                                                background: 'white',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '6px'
                                            }}
                                        >
                                            <RotateCcw style={{ width: '14px', height: '14px' }} />
                                            Effacer
                                        </button>
                                        <button
                                            onClick={() => toggleFavorite(selectedConversion._id)}
                                            style={{
                                                flex: 1,
                                                padding: '8px 12px',
                                                border: `1px solid ${favorites.some(fav => fav.conversionId === selectedConversion._id) ? '#f59e0b' : '#d1d5db'}`,
                                                background: favorites.some(fav => fav.conversionId === selectedConversion._id) ? '#fef3c7' : 'white',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '6px',
                                                color: favorites.some(fav => fav.conversionId === selectedConversion._id) ? '#92400e' : '#374151'
                                            }}
                                        >
                                            <Star style={{ 
                                                width: '14px', 
                                                height: '14px',
                                                fill: favorites.some(fav => fav.conversionId === selectedConversion._id) ? '#f59e0b' : 'none'
                                            }} />
                                            Favori
                                        </button>
                                    </div>

                                    {/* Description */}
                                    {selectedConversion.description && (
                                        <div style={{
                                            padding: '12px',
                                            backgroundColor: '#f8fafc',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            color: '#6b7280',
                                            lineHeight: '1.4'
                                        }}>
                                            <strong style={{ color: '#374151' }}>Description:</strong><br />
                                            {selectedConversion.description}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '32px 16px',
                                    color: '#6b7280'
                                }}>
                                    <Calculator style={{ width: '32px', height: '32px', margin: '0 auto 12px', opacity: 0.5 }} />
                                    <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>
                                        Aucune conversion sélectionnée
                                    </p>
                                    <p style={{ fontSize: '13px' }}>
                                        Cliquez sur une conversion dans la liste pour commencer à calculer.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Recent History & Favorites */}
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '24px', 
                        marginBottom: '32px' 
                    }}>
                        {/* Recent History */}
                        <div style={{
                            backgroundColor: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '20px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '16px'
                            }}>
                                <History style={{ width: '18px', height: '18px', color: '#6b7280' }} />
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                    Historique Récent
                                </h3>
                            </div>
                            
                            {conversionHistory.length > 0 ? (
                                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                                    {conversionHistory.slice(0, 10).map((entry, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                padding: '12px',
                                                border: '1px solid #f3f4f6',
                                                borderRadius: '8px',
                                                marginBottom: '8px',
                                                fontSize: '13px'
                                            }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    <span style={{ fontWeight: '600' }}>{entry.fromValue}</span>
                                                    <span style={{ color: '#6b7280', margin: '0 6px' }}>{entry.fromUnit}</span>
                                                    <ArrowRight style={{ width: '12px', height: '12px', display: 'inline', margin: '0 4px' }} />
                                                    <span style={{ fontWeight: '600', color: '#059669' }}>{entry.toValue}</span>
                                                    <span style={{ color: '#6b7280', marginLeft: '6px' }}>{entry.toUnit}</span>
                                                </div>
                                                <button
                                                    onClick={() => copyToClipboard(`${entry.fromValue} ${entry.fromUnit} = ${entry.toValue} ${entry.toUnit}`)}
                                                    style={{
                                                        padding: '4px',
                                                        border: 'none',
                                                        background: 'none',
                                                        cursor: 'pointer',
                                                        opacity: 0.6
                                                    }}
                                                >
                                                    <Copy style={{ width: '12px', height: '12px' }} />
                                                </button>
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
                                                {new Date(entry.timestamp).toLocaleString('fr-FR')}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                    <p style={{ fontSize: '14px' }}>Aucun historique disponible</p>
                                </div>
                            )}
                        </div>

                        {/* Favorite Conversions */}
                        <div style={{
                            backgroundColor: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '20px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '16px'
                            }}>
                                <Star style={{ width: '18px', height: '18px', color: '#f59e0b', fill: '#f59e0b' }} />
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                    Conversions Favorites
                                </h3>
                            </div>

                            {favorites.length > 0 ? (
                                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                                    {favorites.map((favorite, index) => {
                                        const conversion = conversions.find(c => c._id === favorite.conversionId);
                                        if (!conversion) return null;
                                        
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => setSelectedConversion(conversion)}
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #f3f4f6',
                                                    borderRadius: '8px',
                                                    marginBottom: '8px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                    ':hover': {
                                                        backgroundColor: '#f8fafc'
                                                    }
                                                }}
                                            >
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div>
                                                        <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '2px' }}>
                                                            {conversion.name}
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            {conversion.fromUnit} → {conversion.toUnit}
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleFavorite(conversion._id);
                                                        }}
                                                        style={{
                                                            padding: '4px',
                                                            border: 'none',
                                                            background: 'none',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <Star style={{ width: '14px', height: '14px', color: '#f59e0b', fill: '#f59e0b' }} />
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
                                    <p style={{ fontSize: '14px' }}>Aucune conversion favorite</p>
                                    <p style={{ fontSize: '12px' }}>Cliquez sur l'étoile à côté d'une conversion pour l'ajouter aux favoris.</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.pages > 1 && (
                        <div style={{ 
                            padding: '20px', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <button 
                                onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                                disabled={pagination.page === 1}
                                style={{
                                    padding: '8px 12px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    background: 'white',
                                    cursor: pagination.page === 1 ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Précédent
                            </button>
                            <span style={{ margin: '0 15px' }}>
                                Page {pagination.page} sur {pagination.pages}
                            </span>
                            <button 
                                onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
                                disabled={pagination.page === pagination.pages}
                                style={{
                                    padding: '8px 12px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    background: 'white',
                                    cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Suivant
                            </button>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default UnitechEngineeringConversions;